module.exports = __webpack_public_path__ + "img/icon-button-write.c58b4dff.svg";